import {Pipe, PipeTransform} from '@angular/core';
/**
 * Created by Rumyantsev Daniil on 07.08.2018.
 */

@Pipe({name: 'format'})
export class NumberFormatPipe implements PipeTransform {

  transform(value: number, precision: number): string {

    console.log('Num format pipe', value);

    if( value == null || isNaN(value) || precision == null) {
      return null;
    }

    return value.toFixed(precision);
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/number-format.pipe.ts